import TitleCell from './title-cell.vue'
export default TitleCell



// WEBPACK FOOTER //
// ./src/components/title-cell/index.js